import { asyncAction } from 'lib/actions';

export const fetchAdvancedFilterOptionsAction = asyncAction('advancedFilter/FETCH_OPTIONS');
export const onArtistSearchAdvancedFilterAction = asyncAction('advancedFilter/SEARCH_ARTISTS');
export const advancedFilterFetchTotalAction = asyncAction('advancedFilter/FETCH_TOTAL');

export const fetchAdvancedFilterPaginationAction = asyncAction('advancedFilter/PAGINATION');
